// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"582e7f50","787":"28cb0dcd"}[chunkId] + ".chunk.js";
};